import { render, staticRenderFns } from "./PropertyMaintenanceSystemView.vue?vue&type=template&id=428e8cfa"
import script from "./PropertyMaintenanceSystemView.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceSystemView.vue?vue&type=script&lang=ts"
import style0 from "./PropertyMaintenanceSystemView.vue?vue&type=style&index=0&id=428e8cfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports